import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from '../../functions/mat-tooltip-setter/mat-tooltip-setter';

import { FeatureTileIconVariant, PreLabelStyles } from './feature-tile-variants';

@Component({
  selector: 'app-feature-tile',
  templateUrl: './feature-tile.component.html',
  styleUrls: ['./feature-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureTileComponent {
  @HostListener('mousedown', ['$event'])
  preventDragging(e: MouseEvent): void {
    e.stopPropagation();
  }

  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  readonly optimalCharacterCountWhereEllipsisIsNotNeeded = 27; // without this flex icon is overlapping the feature box
  @Input() label: string;
  @Input() preLabel: string;
  @Input() value: string;
  @Input() assetSource: string;
  @Input() informationTooltip: string;
  @Input() showInformationTooltip = true;
  @Input() isFullHeight = false;
  @Input() error = false;
  @Input() isDynamicHeight = false;
  @Input() isNgContent = false;
  @Input() iconVariant: FeatureTileIconVariant = FeatureTileIconVariant.error_outline;
  @Input() description: string;
  @Input() preLabelStyles: PreLabelStyles;
}
